import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import { IAddress } from 'src/components/registration/signUp/forms/address-form/interface/address.interface';
import { IGeneralInfo } from 'src/components/registration/signUp/forms/generalInfo-form/interface/general-info.interface';
import {
  IFirebaseAccountInfo,
  ISignUpStore,
} from 'src/components/registration/signUp/interface/sign-up.interface';

const initialState: ISignUpStore = {
  generalInfo: {
    fields: {
      firstName: '',
      lastName: '',
      country: '',
      dateOfBirth: '',
      profession: '',
    },
    confirmed: false,
  },
  verificationInfo: {
    fields: { email: '', mobileNumber: '' },
    confirmed: false,
  },
  addressInfo: {
    fields: {
      address: '',
      houseNumber: '',
      isPrivateHouse: 'No',
      apartmentNumber: '',
      entranceNumber: '',
      entranceCode: '',
      latitude: 0,
      longitude: 0,
      country: '',
      city: '',
      street: '',
    },
    confirmed: false,
  },
  passwordInfo: {
    fields: {
      password: '',
      passwordConfirmation: '',
    },
    confirmed: false,
  },
  isSignUp: false,
  firebaseAccount: null,
};

const signUpSlice = createSlice({
  name: 'signUp',
  initialState,
  reducers: {
    setGeneralInfo(state, { payload }: PayloadAction<IGeneralInfo>) {
      state.generalInfo.fields = payload;
      state.generalInfo.confirmed = true;
    },
    setVerificationInfoConfirmed(state, { payload }: PayloadAction<boolean>) {
      state.verificationInfo.confirmed = payload;
    },
    setAddressInfo(state, { payload }: PayloadAction<IAddress>) {
      state.addressInfo.fields = { ...state.addressInfo.fields, ...payload };
      state.addressInfo.confirmed = true;
    },

    setEmailNumber(state, { payload }: PayloadAction<{ email: string; mobileNumber: string }>) {
      state.verificationInfo.fields.email = payload.email;
      state.verificationInfo.fields.mobileNumber = payload.mobileNumber;
    },

    setFirebaseAccount(state, { payload }: PayloadAction<IFirebaseAccountInfo>) {
      state.firebaseAccount = payload;
    },
    clearFirebaseAccount(state) {
      state.firebaseAccount = null;
      state.verificationInfo.confirmed = false;
    },
    setFirebasePasswordSet(state, { payload }: PayloadAction<boolean>) {
      if (state.firebaseAccount) {
        state.firebaseAccount.passwordSet = payload;
      }
      if (payload) {
        state.passwordInfo.confirmed = true;
        state.passwordInfo.fields = { password: '', passwordConfirmation: '' };
        state.isSignUp = true;
      }
    },

    setClear(state) {
      Object.assign(state, initialState);
    },
  },
});

export const {
  setGeneralInfo,
  setAddressInfo,
  setClear,
  setVerificationInfoConfirmed,
  setEmailNumber,
  setFirebaseAccount,
  clearFirebaseAccount,
  setFirebasePasswordSet,
} = signUpSlice.actions;

export default signUpSlice.reducer;
